<template>
  <div class="map">
    <ul class="areaToop" v-for="(item,index) in areaList" :key="index">
      <li>
        <div><p>{{areaList[0].karegionplatform}}:&nbsp; </p><span>{{areaList[0].salesValue|NumFormat}}</span></div>
        <div><p>vs.LY:&nbsp; </p><span>{{areaList[0].ly}}</span></div>
      </li>
      <li>
        <div><p>{{areaList[1].karegionplatform}}:&nbsp; </p><span>{{areaList[1].salesValue|NumFormat}}</span></div>
        <div><p>vs.LY:&nbsp; </p><span>{{areaList[1].ly}}</span></div>
      </li>
      <li>
       <div><p>{{areaList[2].karegionplatform}}:&nbsp; </p><span>{{areaList[2].salesValue|NumFormat}}</span></div>
        <div><p>vs.LY:&nbsp; </p><span>{{areaList[2].ly}}</span></div>
      </li>
      <li>
      <div><p>{{areaList[3].karegionplatform}}:&nbsp; </p><span>{{areaList[3].salesValue|NumFormat}}</span></div>
        <div><p>vs.LY:&nbsp; </p><span>{{areaList[3].ly}}</span></div>
      </li>
      <!-- <li>
       <div><p>{{areaList[4].karegionplatform=='Mid'?'Central':areaList[4].karegionplatform}}:&nbsp; </p><span>{{areaList[4].salesValue|NumFormat}}</span></div>
        <div><p>vs.LY:&nbsp; </p><span>{{areaList[4].ly}}</span></div>
      </li> -->
    </ul>
    <div :id="binId" :style="{width:100}"></div>
  </div>
</template>
<script>
import geoJson from "echarts/map/json/china.json";
export default {
  data() {
    return {
      datalist: [],
      areaList: [],
      achVing:parseFloat(sessionStorage.getItem('achVing'))
    };
  },
  methods: {
    getRegin() {
      this.$addr
        // .get("http://10.216.226.81:8080/mobile_api/sellin/getRegionProList")
        .get("sellin/getRegionProList")
        .then(res => {
          this.datalist = [];
          var arrList = res.data.data;
          arrList.map((item, index) => {
            this.datalist.push(
              Object.assign({}, item, {
                name: item.province,
                area: item.karegionplatform,
                seriesName: item.karegionplatform,
                type: item.regionEn,
                ly: item.ly,
                value: item.salesValue
              })
            );
          });
          var hash = {};
          this.areaList = arrList.reduce(function(item, next) {
            hash[next.karegionplatform]
              ? ""
              : (hash[next.karegionplatform] = true && item.push(next));
            return item;
          }, []);
          this.DrewMap();
        })
        .catch(error => {
          this.$toast("接受数据失败");
        });
    },
    DrewMap() {
      for (let item of this.datalist) {
        if (item.area === "East") {
          if (parseFloat(item.ly) >= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#d4e1b4"
              },
              emphasis: {
                areaColor: "#d4e1b4"
              }
            };
          } else if (parseFloat(item.ly) >= this.achVing-5 && parseFloat(item.ly) <= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#fde8b4"
              },
              emphasis: {
                areaColor: "#fde8b4"
              }
            };
          } else if (parseFloat(item.ly) < this.achVing-5){
            item.itemStyle = {
              normal: {
                areaColor: "#f9c6bd"
              },
              emphasis: {
                areaColor: "#f9c6bd"
              }
            };
          }
        } else if (item.area === "North") {
           if (parseFloat(item.ly) >= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#d4e1b4"
              },
              emphasis: {
                areaColor: "#d4e1b4"
              }
            };
          } else if (parseFloat(item.ly) >= this.achVing-5 && parseFloat(item.ly) <= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#fde8b4"
              },
              emphasis: {
                areaColor: "#fde8b4"
              }
            };
          } else if (parseFloat(item.ly) < this.achVing-5){
            item.itemStyle = {
              normal: {
                areaColor: "#f9c6bd"
              },
              emphasis: {
                areaColor: "#f9c6bd"
              }
            };
          }
        } else if (item.area === "Mid") {
           if (parseFloat(item.ly) >= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#d4e1b4"
              },
              emphasis: {
                areaColor: "#d4e1b4"
              }
            };
          } else if (parseFloat(item.ly) >= this.achVing-5 && parseFloat(item.ly) <= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#fde8b4"
              },
              emphasis: {
                areaColor: "#fde8b4"
              }
            };
          } else if (parseFloat(item.ly) < this.achVing-5){
            item.itemStyle = {
              normal: {
                areaColor: "#f9c6bd"
              },
              emphasis: {
                areaColor: "#f9c6bd"
              }
            };
          }
        } else if (item.area === "West") {
           if (parseFloat(item.ly) >= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#d4e1b4"
              },
              emphasis: {
                areaColor: "#d4e1b4"
              }
            };
          } else if (parseFloat(item.ly) >= this.achVing-5 && parseFloat(item.ly) <= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#fde8b4"
              },
              emphasis: {
                areaColor: "#fde8b4"
              }
            };
          } else if (parseFloat(item.ly) < this.achVing-5){
            item.itemStyle = {
              normal: {
                areaColor: "#f9c6bd"
              },
              emphasis: {
                areaColor: "#f9c6bd"
              }
            };
          }
        } else if (item.area === "South") {
            if (parseFloat(item.ly) >= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#d4e1b4"
              },
              emphasis: {
                areaColor: "#d4e1b4"
              }
            };
          } else if (parseFloat(item.ly) >= this.achVing-5 && parseFloat(item.ly) <= this.achVing) {
            item.itemStyle = {
              normal: {
                areaColor: "#fde8b4"
              },
              emphasis: {
                areaColor: "#fde8b4"
              }
            };
          } else if (parseFloat(item.ly) < this.achVing-5){
            item.itemStyle = {
              normal: {
                areaColor: "#f9c6bd"
              },
              emphasis: {
                areaColor: "#f9c6bd"
              }
            };
          }
        }
      }

      const myChart = this.$echarts.init(document.getElementById("NDC"));
      myChart.setOption({
        geo: {
          roam: false,
          zoom: 1,
          map: "china",
          top: "20",
          left: "20",
          aspectScale: 0.8,
          layoutSize: "80%",
          selectedMode: true,
          regions: [
            {
              name: "南海诸岛",
              value: 0,
              itemStyle: { normal: { opacity: 0, label: { show: false } } }
            }
          ],
          tooltip: {
            trigger: "item"
          },
          label: {
            normal: {
              show: false, //显示省份标签
              textStyle: { color: "#c71585" } //省份标签字体颜色
            },
          },
          itemStyle: {
            normal: {
              borderWidth: 0.5, //区域边框宽度
              borderColor: "#fff", //区域边框颜色
              label: { show: false }
            },
            emphasis: {
              show: false,
              borderWidth: 0.5,
              borderColor: "#4b0082",
              areaColor: "#ffdead"
            }
          }
        },
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo",
            data: this.convertData(this.datalist),
            symbolSize: 20,
            symbolRotate: 35,
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: true
              },
              emphasis: {
                show: false
              }
            },
            tooltip: {
              show: false, //不显示提示标签
              formatter: "{c}", //提示标签格式
              backgroundColor: "rgba(255,255,255,0.65)", //提示标签背景颜色
              borderColor: "#D2D2D8",
              borderWidth: 0.5,
              textStyle: {
                fontFamily: "PingFangSC-Medium",
                fontSize: "6px",
                color: "#332A66",
                textAlign: "center"
              } //提示标签字体颜色
            },
            itemStyle: {
              normal: {
                color: "#57c610"
              }
            }
          },
          {
            type: "map",
            mapType: "china",
            roam: false,
            zoom: 1.2,
            tooltip: {
              show: true //不显示提示标签
            },
            label: {
              normal: {
                show: false //显示省份标签
              },
              emphasis: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                borderWidth: 0.5, //区域边框宽度
                borderColor: "#fff", //区域边框颜色
                label: { show: true }
              },
              emphasis: {
                show: true
              }
            },
            data: this.datalist,
            nameMap: {}
          }
        ]
      });
    },
    convertData(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        res.push({
          name: data[i].name,
          area: data[i].area,
          type: data[i].type,
          ly: data[i].ly,
          salesValue: data[i].salesValue
        });
      }
      return res;
    }
  },
  props: {
    binId: {
      type: String
    }
  },
  created() {
    this.getRegin();
  },
  beforeMount(){
   
  }
};
</script>
<style>
.map {
  width: 100%;
  padding: 0 10px;
  position: relative;
}
.map > #NDC {
  width: 250px;
  height: 180px;
}
.areaToop {
  position: absolute;
  z-index: 2;
  background-color: #f9c6bd;
}
.areaToop li {
  display: block;
  min-width: 55px;
  min-height: 25px;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid #d2d2d8;
  text-align: center;
  padding: 2px 5px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  position: absolute;
}
.areaToop li>div{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.areaToop li div p {
  min-width: 30px;
  text-align: right;
  font-family: "PingFangSC-Medium";
  font-size: 7px;
  color: #4e4585;
}
.areaToop li div span{
  min-width: 30px;
  text-align: left;
  font-family: "PingFangSC-Medium";
  font-size: 7px;
  color: #4e4585;
}
.areaToop li:nth-child(1) {
  border-radius: 10px 10px 0px 10px;
  left: 110px;
  top: 100px;
}
.areaToop li:nth-child(2) {
  border-radius: 10px 10px 10px 0px;
  left: 195px;
  top: 8px;
}
.areaToop li:nth-child(3) {
  border-radius: 10px 0px 10px 10px;
  left: 80px;
  top: 145px;
}
.areaToop li:nth-child(4) {
  border-radius: 10px 10px 0px 10px;
  left: 25px;
  top: 66px;
}
.areaToop li:nth-child(5) {
  border-radius: 10px 10px 10px 0px;
  left: 170px;
  top: 60px;
}
</style>


// WEBPACK FOOTER //
// src/components/ButSecoend2/Public/Map.vue